export default __webpack_public_path__ + "media/hubspot-logo.17d0f.png";